<div class="container my-2">
  <div #certificate class="row justify-content-center test">
    <div class="image-container position-relative text-center">

      <img src="../../../../assets/img/agaram-selvi-certificate.png"
           class="img-fluid w-100"
           alt="Certificate">

      <!-- Applicant Name -->
      <p class="overlay-text applicant-name">
        This is to certify that <b> {{ certificateDetails?.namePrefix }}.
        {{ certificateDetails?.applicantName }}</b>
      </p>

      <p class="overlay-text line-gap">has successfully completed the training program on</p>
      <!-- Role -->
      <p class="overlay-text role">
         <b>{{ certificateDetails?.courseDetails }}</b> from <b>{{ certificateDetails?.courseStartDate | date:'dd-MM-yyyy' }}</b> to
        <b>{{ certificateDetails?.courseEndDate | date:'dd-MM-yyyy' }}</b>
      </p>

      <!-- Training Date -->
      <!-- <p class="overlay-text date">
        held from Indian Export Organisations
        {{ certificateDetails?.courseStartDate | date:'dd-MM-yyyy' }}
        to
        {{ certificateDetails?.courseEndDate | date:'dd-MM-yyyy' }}
        at Chennai
      </p> -->

      <!-- Issued Date -->
      <p class="overlay-text issued-date">
        {{ certificateDetails?.issueDate | date:'dd-MM-yyyy' }}
      </p>

      <!-- Certificate Number -->
      <p class="overlay-text cert-no">
        {{ certificateDetails?.certificateCode }}
      </p>

      <!-- ✅ QR CODE INSIDE IMAGE -->
      <img
        [src]="qrCodeImage"
        alt="QR Code"
        class="overlay-qrcode">

    </div>
  </div>
</div>
